import React, { useState, useEffect } from "react";
import Select from "react-select";
import _ from "lodash";
import { links } from "../constants/selections";
const attributes = ["left", "middle", "right"];
const ThreeTabConfigItem = ({ initial, threeTabBarName, onChangeConfig }) => {
  const [linkSet, setLinkSet] = useState(initial);
  useEffect(() => {
    setLinkSet(initial);
  }, [initial]);
  const handleChange = (attribute) => (value) => {
    const cloned = { ...linkSet };
    cloned[attribute] = value.value;
    setLinkSet(cloned);
    onChangeConfig(cloned);
  };
  return (
    <div>
      <h4 style={{ marginBottom: 0, marginTop: 50 }}>
        Edit {threeTabBarName}{" "}
      </h4>
      {attributes.map((attribute) => (
        <div className="form-group">
          <label>{_.capitalize(attribute)} link</label>
          <div className="input-container mb-2">
            <Select
              value={{ value: linkSet[attribute], label: linkSet[attribute] }}
              onChange={handleChange(attribute)}
              options={links}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
export default ThreeTabConfigItem;



// WEBPACK FOOTER //
// ./src/screens/BespokeExplore/components/ThreeTabConfigItem.js